
import { createFileRoute } from '@tanstack/react-router';
import { useMember, mayCreateResource } from '@/lib/use-session';
import { ResourcesListBody } from '@/components/resources/ResourcesListBody';
import { type ResourcesSearchInput } from '@/lib/queries/resources';

function pickStr(v: unknown): string | undefined {
  return typeof v === 'string' && v.length > 0 ? v : undefined;
}
function pickStrArr(v: unknown): string[] | undefined {
  if (Array.isArray(v)) {
    const arr = v.filter((s) => typeof s === 'string') as string[];
    return arr.length > 0 ? arr : undefined;
  }
  if (typeof v === 'string' && v.length > 0) return [v];
  return undefined;
}

export const Route = createFileRoute('/_public/resources/')({
  validateSearch: (raw: Record<string, unknown>): ResourcesSearchInput => ({
    ...(pickStr(raw.q) ? { q: pickStr(raw.q) as string } : {}),
    ...(pickStr(raw.scope) ? { scope: pickStr(raw.scope) as string } : {}),
    ...(pickStrArr(raw.tags) ? { tags: pickStrArr(raw.tags) as string[] } : {}),
    ...(pickStr(raw.shelf) ? { shelf: pickStr(raw.shelf) as string } : {}),
  }),
  component: ResourcesPage,
});

function ResourcesPage() {
  const me = useMember();
  const signedIn = me !== null;
  const canAuthor = me !== null && mayCreateResource(me.platformRole);
  return <ResourcesListBody canAuthor={canAuthor} signedIn={signedIn} />;
}
